import apiClient from 'config/axios.config';

const bookingServices = {
  getBookings: async (params = {}) => {
    const response = await apiClient.get('/booking', { params });
    return response.data;
  },

  getBookingById: async (id) => {
    const response = await apiClient.get(`/booking/${id}`);
    return response.data;
  },

  /*
  updateBooking: async (id, data) => {
    const response = await apiClient.put(`/admin/bookings/${id}`, data);
    return response.data;
  },

  cancelBooking: async (id, data) => {
    const response = await apiClient.post(`/booking/${id}/cancel`, data);
    return response.data;
  },

  rejectBooking: async (id, data) => {
    const response = await apiClient.post(`/booking/${id}/reject`, data);
    return response.data;
  },

  rescheduleBooking: async (id, data) => {
    const response = await apiClient.post(`/booking/${id}/reschedule`, data);
    return response.data;
  },

  addRating: async (id, data) => {
    const response = await apiClient.post(`/admin/bookings/${id}/rating`, data);
    return response.data;
  },

  assignStaff: async (id, data) => {
    const response = await apiClient.post(`/admin/bookings/${id}/assign-staff`, data);
    return response.data;
  },
  */

 exportBookings: async ({
  status,
  bookingType,
  paymentStatus,
  categoryId,
  subcategoryId,
  startDate,
  endDate,
  sortBy,
  sortOrder,
  type,
}) => {
  const params =
    new URLSearchParams({
      status:
        status || '',

      bookingType:
        bookingType || '',

      paymentStatus:
        paymentStatus || '',

      categoryId:
        categoryId || '',

      subcategoryId:
        subcategoryId || '',

      startDate:
        startDate || '',

      endDate:
        endDate || '',

      sortBy:
        sortBy || 'createdAt',

      sortOrder:
        sortOrder || 'desc',

      type:
        type || '',
    });

  for (const [key, value] of [
    ...params.entries(),
  ]) {
    if (!value) {
      params.delete(key);
    }
  }

  return apiClient.get(
    `/booking/export?${params.toString()}`,
    {
      responseType: 'blob',
    }
  );
},
};

export default bookingServices;
